import useFetch from './useFetch';
import usePromise from './usePromise';
import useUpdateEffect from './useUpdateEffect';
export const useFetchAuto = (fetch, dependencies) => {
    const [request, reload] = useFetch(fetch);
    useUpdateEffect(() => {
        reload();
    }, dependencies);
    return request;
};
export const useFetchAutoAnd = (fetch, dependencies) => {
    const [request, reload] = useFetch(fetch);
    useUpdateEffect(() => {
        reload();
    }, dependencies);
    return [request, reload];
};
export const useFetchAutoPromise = (fetch, dependencies) => {
    const [request, reload] = useFetch(fetch);
    useUpdateEffect(() => {
        reload();
    }, dependencies);
    return usePromise(request);
};
export default useFetchAuto;
